module.exports = __webpack_public_path__ + "img/Frame_38.62e975f5.png";